export enum LoadedComponentEnum {
	BUTTON,
	TEXTBOX,
	TEXT,
	LOGO,
}
